module.exports = __webpack_public_path__ + "img/guide.22e86cb6.jpg";